"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.resultMessages = exports.Result = void 0;
const schema_1 = require("../../../../schema");
var Result;
(function (Result) {
    Result["ABNORMAL"] = "ABNORMAL";
    Result["NORMAL"] = "NORMAL";
})(Result || (exports.Result = Result = {}));
exports.resultMessages = {
    [Result.ABNORMAL]: {
        id: "ltx.phaseI.consultations.boneScan.result.ABNORMAL",
        defaultMessage: "Igen"
    },
    [Result.NORMAL]: {
        id: "ltx.phaseI.consultations.boneScan.result.NORMAL",
        defaultMessage: "Nem"
    }
};
const result = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Result.ABNORMAL),
    schema_1.Schema.singleChoiceItem(Result.NORMAL)
])
    .expiration(15552000)
    .interpretation({ vocab: "ltx", code: "bone_scan" });
const resultComment = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../result} === "ABNORMAL"`), schema_1.Schema.string()
    .optional()
    .maxLength(10000)
    .interpretation({ vocab: "ltx", code: "bone_scan_comment" }));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ result, resultComment })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "169069000" });
